/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { forEach, get } from 'lodash';

const URL_ATTR = {
  '0': 'leftColumnSelectedItem.id',
  __OBJ_TYPE__: 'leftColumnType.model',
  __MAP_TYPE__: 'rightColumnObjectType.model',
  __BASE_TYPE__: 'selected.model',
  __REL_TYPE__: 'type',
};

export function buildURL(template: string, data: any): string {
  forEach(URL_ATTR, (val, key) => {
    template = template.replace(key, get(data, val));
  });

  return template;
}
